// extracted by mini-css-extract-plugin
export default {"link":"link_Wb3ir","arrow":"arrow_OEnDU","wrapper":"wrapper_uaivi"};